<div class="bg"></div>
<div class="bg bg2"></div>
<div class="bg bg3"></div>
<div class="content">
    <div class="login-bodyx">
        <div id="login-wrapper">
            <br>
            <br>
            <br>
            <br>
            <div id="login-container">
                <img src="/assets/images/green.png" width="80" class="mb-3"/>
                <form [formGroup]="loginForm" (ngSubmit)="login()">
                    <div class="grid p-fluid">
                        <div class="col-12">
                            <input type="text"
                                   pInputText
                                   formControlName="username"
                                   placeholder="Username"/>
                        </div>
                        <div class="col-12">
                            <input type="password"
                                   pInputText
                                   formControlName="password"
                                   placeholder="Password"/>
                        </div>
                        <div class="col-12">
                            <p-button type="submit"
                                      label="Sign In"
                                      icon="pi pi-user"
                                      [disabled]="!loginForm.valid">
                            </p-button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="login-footer">Golfdigg {{version}}</div>
        </div>
    </div>
</div>


